import axios from 'axios';
import { format, parse ,isValid } from 'date-fns';
import {
  MDBCard,
  MDBCardBody,
  MDBCardFooter,
  MDBCardHeader,
  MDBCardImage,
  MDBCardTitle,
  MDBChip,
  MDBCol,
  MDBContainer,
  MDBDatepicker,
  MDBRow,
  MDBSelect,
  MDBSpinner
} from 'mdb-react-ui-kit';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
const Report = () => {
  const data = {
    totalAmountSpentOnAllSoFar: "$1232123.00",
    items: [
      {
        name: "ABC",
        totalPrice: "$934.33",
        image: "https://opengrit.com/images/stats2",
        historyId: "historyId",
        entity: "entityId",
        companies: [
          {
            name: " Tesco",
            originalNames: ["AbX", "ss"],
            min: {
              price: "$2.00",

              purchaseDate: "dd/mm/yyyy"
            },
            max: {
              price: "$2.00",

              purchaseDate: "dd/mm/yyyy"
            }
          },
          {
            name: "Sainsbury",
            originalNames: ["ABO"],
            min: {
              price: "$2.00",

              purchaseDate: "dd/mm/yyyy"
            },
            max: {
              price: "$2.00",

              purchaseDate: "dd/mm/yyyy"
            }
          }
        ]
      },
      {
        name: "def",
        totalPrice: "$678.33",
        image: "https://opengrit.com/images/stats2",
        historyId: "historyId",
        entity: "entityId",
        companies: [
          {
            name: " Tesco",
            originalNames: ["AbX", "ss"],
            min: {
              price: "$2.00",

              purchaseDate: "dd/mm/yyyy"
            },
            max: {
              price: "$2.00",
              purchaseDate: "dd/mm/yyyy"
            }
          },
          {
            name: "Sainsbury",
            min: {
              price: "$2.00",
              purchaseDate: "dd/mm/yyyy"
            },
            max: {
              price: "$2.00",
              purchaseDate: "dd/mm/yyyy"
            }
          }
        ]
      },
    ]
  };

  const [noOfDays, setNoOfDays] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [statisticsData, setStatisticsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_INVENTORY_URL;
  const handleNoOfDaysChange = (event) => {
    const selectedValue = event.value;
    setNoOfDays(selectedValue);
  };
  const formatsToCheck = [
    "MM/dd/yyyy h:mm:ssa",
    "MM/dd/yyyy"
  ];


  const convertToDate = (dateString) => {
    for (const formatString of formatsToCheck) {
      const parsedDate = parse(dateString, formatString, new Date());
      if (isValid(parsedDate)) {
        return parsedDate;
      }
    }
    return null; // Return null if none of the formats match
  };
  
  const formatDate = (dateString) => {
    const parsedDate = convertToDate(dateString);
    if (parsedDate) {
      return format(parsedDate, 'dd-MMM-yyyy h:mm:ssa');
    } else {
      // Handle invalid date string
      return null;
    }
  };
  const handleStartDateChange = (event) => {
    setNoOfDays('');
    setStartDate('');
    const selectedValue = event;
    setStartDate(selectedValue);
  };
  const handleEndDateChange = (event) => {
    const selectedValue = event;
    setEndDate(selectedValue);
  };
  const fetchItems = useCallback(async () => {
    let response;
    try {


      if (startDate && endDate) {
        response = await axios.get(`${baseUrl}/statistics?startDate=${startDate}?endDate=${endDate}`);
      } else if (startDate) {
        response = await axios.get(`${baseUrl}/statistics?startDate=${startDate}`);
      } else {
        response = await axios.get(`${baseUrl}/statistics?noOfDays=${noOfDays}`);
      }

      if (response.data.totalAmountSpentOnAllSoFar) {

    

        const formattedData = response?.data?.items?.map(item => {
          return {
            ...item,
            companies: item?.companies?.map(company => {
           
              const formattedMinDate = formatDate(company?.min?.purchaseDate);
             


            const formattedMaxDate = formatDate(company?.max?.purchaseDate);
       
            

              return {
                ...company,
                min: {
                  ...company?.min,
                  purchaseDate: formattedMinDate,
                },
                max: {
                  ...company?.max,
                  purchaseDate: formattedMaxDate,
                },
              };
            }),
          };
        });



        
        
  
        setStatisticsData({
          ...response.data,
          items: formattedData,
        });
      } else {
        navigate('/no-inventory');
      }
    } catch (error) {
      console.error(error);
    } finally {
      // setStatisticsData(data);
      if (!response?.data?.totalAmountSpentOnAllSoFar) {
        setStatisticsData(data);
      }
      setIsLoading(false);
    }
  }, [baseUrl, navigate, noOfDays]);


  useEffect(() => {
    fetchItems()
  }, [fetchItems]);


  // Original date string
  const originalDateStr = "29-Jun-2023 4:43:01P";

  // Parse the original date string into a Date object
  const originalDate = new Date(originalDateStr);

  // Create an array of month names
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  // Format the date as 'dd, dddd, mmmm, yyyy'
//  const formattedDate = `${originalDate.getDate()}, ${originalDate.toLocaleString('en-US', { weekday: 'long' })}, ${monthNames[originalDate.getMonth()]}, ${originalDate.getFullYear()}`;


  return isLoading ? (
    <div className='d-flex m-5 justify-content-center  grainy-gradient-intro'>
      <MDBSpinner style={{ width: '3rem', height: '3rem' }}>
        <span className='visually-hidden'>Loading...</span>
      </MDBSpinner>
    </div>
  ) : (
    statisticsData?.items?.length > 0 && (
      <section className='mb-10 position-relative'>

        <MDBContainer className='grainy-gradient-intro'>


          <MDBRow className='justify-content-center mt-2  grainy-gradient-intro'>
            <MDBCol className='mb-md-0 mb-4 justify-content-center'>
              <MDBCard className='text-center'>
                <MDBCardBody>
                  <p className='mb-1'>Total Amount of Money spent on all Items</p>
                  <h1 className='mb-0 text-primary'>{statisticsData.totalAmountSpentOnAllSoFar}</h1>

                </MDBCardBody>
              </MDBCard>
            </MDBCol>


          </MDBRow>

          <MDBRow className='grainy-gradient-intro'>
            <MDBCol md='12' className='mb-4'>
              <MDBCard className='mt-5'>
                <MDBCardHeader className='text-center' >
                  <h4 className=" fw-bold capitalize text-dark"> Items Of Max Expenditure</h4>
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBRow>
                    <MDBCol md='6' className='mb-2 mb-md-0'>
                      <MDBSelect
                        label='Get Max spending Items for'
                        value={noOfDays} // Set the selected value
                        onChange={handleNoOfDaysChange} // Handle the change
                        data={[
                          { text: 'Last 7 days', value: '7' },
                          { text: 'Last 28 days', value: '28' },
                          { text: 'Last 90 days', value: '90' },
                          { text: 'Last 180 days', value: '180' },
                          { text: 'Last 360 days', value: '360' },
                          { text: 'Last 720 days', value: '720' },
                        ]}
                      />
                    </MDBCol>
                    <MDBCol md='6'>
                      <MDBDatepicker value={startDate} setValue={setStartDate} labelText='Get Max spending Items on and before' disableFuture onChange={handleStartDateChange} />
                    </MDBCol>

                  </MDBRow>
                  {/* 
                                    <MDBRow className='mt-2'><MDBCol md='6'> <hr /> </MDBCol> <MDBCol className='text-center' md='1'>or</MDBCol> <MDBCol md='5'><hr /></MDBCol></MDBRow> */}
                  <MDBRow className='mt-5'>
                    <MDBCol md='4' className='mt-2'>
                      <p className="text-center">Get Max Spending Items Between: </p>
                    </MDBCol>
                    <MDBCol md='4' className='mt-2'>
                      <MDBDatepicker value={startDate} setValue={setStartDate} labelText='Date' disableFuture onChange={handleStartDateChange} />
                    </MDBCol>

                    <MDBCol md='4' className='mt-2'>
                      <MDBDatepicker value={endDate} setValue={setEndDate} labelText='Date' disabled={!startDate} disableFuture onChange={handleEndDateChange} />
                    </MDBCol>
                  </MDBRow>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>

          <MDBRow className='mt-2 '>
            {statisticsData?.items?.map((stat, index) => (
              <MDBCol key={index} className='d-flex justify-content-center'>
                <MDBCard className='d-flex flex-column  mb-4 justify-content-between' tag='section'>
                  <div className='position-relative d-inline-block'>
                    {stat.image && (
                      <MDBCardImage
                        src={stat.image}
                        alt='...'
                        position='top'
                        className='mb-3 img-thumbnail rounded'
                        fluid
                      />
                    )}
                  </div>
                  <MDBCardHeader className='text-center align-items-center justify-content-center'>
                    <MDBChip className='text-center justify-content-center'>
                      <h3 className='fw-bold text-uppercase text-dark mb-0 d-flex text-center ' style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis', maxWidth: '100%' }}>
                        {stat.name}: {stat.totalPrice}
                      </h3>
                    </MDBChip>
                  </MDBCardHeader>

                  {stat?.companies &&
  <MDBCardBody>
    <MDBCardTitle className='text-center'>
      <div className='d-flex justify-content-center align-items-center text-center'></div>
    </MDBCardTitle>
    {stat?.companies &&
      Object.entries(stat?.companies).map(([storeName, storeData]) => (
        <MDBContainer fluid key={storeName}>
          <MDBRow className='justify-content-center fw-bold' key={storeName}>
            <MDBCol md='12'>
              <section>
                <h5>{storeName}</h5> {/* Ensure this is a string */}
                {storeData?.originalNames?.map((originalName, index) => (
                  <span key={index} className='mb-0 me-2 text-capitalize'>
                    {originalName.name} {/* Ensure you're rendering a string property */}
                  </span>
                ))}
                <MDBRow>
                  <MDBRow className='mb-2'>
                    <MDBCard>
                      <MDBCardBody>
                        <p className='text-muted mb-1'>Min</p>
                        {storeData?.min?.purchaseDate && (
                          <p className='mb-0'>Date: {storeData?.min?.purchaseDate}</p>
                        )}
                        <p className='mb-0'>Price: {storeData?.min?.price}</p>
                      </MDBCardBody>
                    </MDBCard>
                  </MDBRow>

                  <MDBRow>
                    <MDBCard className='mb-4'>
                      <MDBCardBody>
                        <p className='text-muted mb-1'>Max</p>
                        {storeData?.max?.purchaseDate && (
                          <p className='mb-0'>Date: {storeData?.max?.purchaseDate}</p>
                        )}
                        <span className='mb-0'>Price: {storeData?.max?.price}</span>
                      </MDBCardBody>
                    </MDBCard>
                  </MDBRow>
                </MDBRow>
              </section>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      ))
    }
  </MDBCardBody>
}

                </MDBCard>
              </MDBCol>
            ))}
            <MDBCardFooter className='text-center justify-content-center'>
              <h5 className='mb-4'>
                {(!startDate && !endDate && !noOfDays) ? <small className='text-muted me-1 fw-normal'>You spent highest amount of money on above items as of Today</small> : <small className='text-muted me-1 fw-normal'>You spent highest amount of money on above items during</small>}
                <br />
                {(startDate && endDate) ? <span className='text-center justify-content-center'>{startDate} and {endDate}</span> : (startDate ? <span className='text-center justify-content-center'> {startDate} and Before</span> : noOfDays && <span className='text-center justify-content-center'> Last {noOfDays} Days</span>)}
              </h5>
            </MDBCardFooter>
          </MDBRow>
        </MDBContainer>
      </section>
    )
  );
};

export default Report;
